import React from "react";

import { Stack, Paper, Typography } from "@mui/material";

import useFeatureAccess from "@app/common/hooks/useFeatureAccess";
import { usePageTitle } from "@app/utils/hooks";

import CalendarConnectUpsell from "./CalendarConnectUpsell";
import IntegrationConnectUpsell from "./IntegrationConnectUpsell";

const CalendarTakeover = () => {
  usePageTitle("Calendar");

  const { canConnectCalendars, canConnectProductivityIntegrations } =
    useFeatureAccess();

  return (
    <Stack
      sx={{ height: "100%", width: "100%" }}
      alignItems="center"
      justifyContent="center"
    >
      <Paper elevation={5} sx={{ width: "445px", padding: "40px" }}>
        <Stack sx={{ textAlign: "center" }} spacing={4} alignItems="center">
          {canConnectCalendars ? (
            <CalendarConnectUpsell />
          ) : canConnectProductivityIntegrations ? (
            <IntegrationConnectUpsell />
          ) : (
            <Typography
              variant="bodyPrimaryReg"
              fontWeight={600}
              color="shades.neutral.800"
            >
              Calendar integrations have been disabled for your Workspace
            </Typography>
          )}
        </Stack>
      </Paper>
    </Stack>
  );
};

export default CalendarTakeover;
